import axios from 'axios';
import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import "../../services/ApiRest"
import { ApiUrl } from '../../services/ApiRest';


const cookie = new Cookies();
const urlEstudiante = ApiUrl + "estudiantes/"; //pasar id del estudiante
const idEstudiante = cookie.get("idEstudiante");
const nombres = cookie.get("nombres");
const apellidos = cookie.get("apellidos");


export default class VerPerfil extends Component {
    constructor(props) {
        super(props)

        this.state = {
            estudiante: [],

        }

    }




    componentDidMount() {

        axios.get(urlEstudiante + idEstudiante + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data[1];
                this.setState({ estudiante });
            })
    }



    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0 mt-5 mt-sm-0">
                    <div className="back-istmas">
                        <i className="far fa-user bounce-custom"></i>
                        <b className="mb-0 fw-semibold"> Perfil Estudiante</b>
                    </div>
                    <div className="card-body">
                        <form
                            id="create-course-form"
                            onSubmit={this.inscribirEstudiante}
                            style={{ padding: 10 }}
                        >
                            <div className="row">
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Nombres:</b> {nombres}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Apellidos:</b> {apellidos}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Cédula de Identidad:</b> {this.state.estudiante.numero_identificacion_estudiante}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Fecha de Nacimiento:</b> {this.state.estudiante.fecha_nacimiento_estudiante}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Correo electrónico:</b> {this.state.estudiante.email_estudiante}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Teléfono celular:</b> {this.state.estudiante.celular_estudiante}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Dirección:</b> {this.state.estudiante.direccion_estudiante}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 centrar">
                                    <div className="mb-3">
                                        <label className="form-label small text-azul">
                                            <b>Teléfono Convencional:</b> {this.state.estudiante.convencional_estudiante}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
